import moment from "moment";

export const fileSizeInKB = bytes => {
  return (bytes / 1024).toFixed(2); // convert bytes to KB and round to 2 decimal places
};

export const fileSizeInMB = bytes => {
  return (bytes / (1024 * 1024)).toFixed(2); // convert bytes to MB and round to 2 decimal places
};

export const formatDate = date => {
  return moment(date).format("MM/DD/YYYY - HH:mm");
};
